const reportingRoot = '/reporting';

export const configurationReportingRoutes = (root: string) => {
  const reportsRoot = `${root}${reportingRoot}/reports`;

  return {
    root: `${root}${reportingRoot}`,
    reports: {
      root: reportsRoot,
      createNew: `${reportsRoot}/add/:reportType`,
      details: `${reportsRoot}/:id/details`,
      linkedVariables: `${reportsRoot}/:id/linked-variables`,
    },
  };
};
